import SnowflakeConfig from './SnowflakeConfig';

export default SnowflakeConfig;
